/* @generated from adl module ids.common */

import * as ADL from './../runtime/adl';
import * as common_strings from './../common/strings';

export type StateCode = string;

const StateCode_AST : ADL.ScopedDecl =
  {"moduleName":"ids.common","decl":{"annotations":[{"v1":{"moduleName":"common.ui","name":"ValidRegex"},"v2":{"regex":"^[A-Z]{2}[A-Z]?$","description":"A 2 or 3 letter state/province code"}}],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}},"name":"StateCode","version":{"kind":"nothing"}}};

export const snStateCode: ADL.ScopedName = {moduleName:"ids.common", name:"StateCode"};

export function texprStateCode(): ADL.ATypeExpr<StateCode> {
  return {value : {typeRef : {kind: "reference", value : snStateCode}, parameters : []}};
}

export type CountryCode = string;

const CountryCode_AST : ADL.ScopedDecl =
  {"moduleName":"ids.common","decl":{"annotations":[{"v1":{"moduleName":"common.ui","name":"ValidRegex"},"v2":{"regex":"^[A-Z]{2}$","description":"An ISO 316-1 alpha-2 format"}}],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}},"name":"CountryCode","version":{"kind":"nothing"}}};

export const snCountryCode: ADL.ScopedName = {moduleName:"ids.common", name:"CountryCode"};

export function texprCountryCode(): ADL.ATypeExpr<CountryCode> {
  return {value : {typeRef : {kind: "reference", value : snCountryCode}, parameters : []}};
}

/**
 * TODO(jess): Make a validation annotation to ensure that this value is between 0 and 5.
 */
export type StarRating = number;

const StarRating_AST : ADL.ScopedDecl =
  {"moduleName":"ids.common","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"TODO(jess): Make a validation annotation to ensure that this value is between 0 and 5.\n"}],"type_":{"kind":"newtype_","value":{"typeParams":[],"default":{"kind":"nothing"},"typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}}},"name":"StarRating","version":{"kind":"nothing"}}};

export const snStarRating: ADL.ScopedName = {moduleName:"ids.common", name:"StarRating"};

export function texprStarRating(): ADL.ATypeExpr<StarRating> {
  return {value : {typeRef : {kind: "reference", value : snStarRating}, parameters : []}};
}

export interface Address {
  /**
   * Address line 1
   */
  line1: common_strings.StringNE;
  /**
   * Address line 2
   */
  line2: (common_strings.StringNE|null);
  /**
   * City
   */
  city: common_strings.StringNE;
  /**
   * 2-letter or 3-letter state/province code for Australia, Canada & USA
   */
  stateProvinceCode: (StateCode|null);
  /**
   * Name of state/province.
   */
  stateProvinceName: (common_strings.StringNE|null);
  /**
   * Postal/zip code
   */
  postalCode: (common_strings.StringNE|null);
  /**
   * 2-letter country code, in ISO 316-1 alpha-2 format.
   */
  countryCode: (CountryCode|null);
}

export function makeAddress(
  input: {
    line1: common_strings.StringNE,
    line2: (common_strings.StringNE|null),
    city: common_strings.StringNE,
    stateProvinceCode: (StateCode|null),
    stateProvinceName: (common_strings.StringNE|null),
    postalCode: (common_strings.StringNE|null),
    countryCode: (CountryCode|null),
  }
): Address {
  return {
    line1: input.line1,
    line2: input.line2,
    city: input.city,
    stateProvinceCode: input.stateProvinceCode,
    stateProvinceName: input.stateProvinceName,
    postalCode: input.postalCode,
    countryCode: input.countryCode,
  };
}

const Address_AST : ADL.ScopedDecl =
  {"moduleName":"ids.common","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Address line 1\n"}],"serializedName":"line1","default":{"kind":"nothing"},"name":"line1","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Address line 2\n"}],"serializedName":"line2","default":{"kind":"nothing"},"name":"line2","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"City\n"}],"serializedName":"city","default":{"kind":"nothing"},"name":"city","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"2-letter or 3-letter state/province code for Australia, Canada & USA\n"}],"serializedName":"stateProvinceCode","default":{"kind":"nothing"},"name":"stateProvinceCode","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.common","name":"StateCode"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Name of state/province.\n"}],"serializedName":"stateProvinceName","default":{"kind":"nothing"},"name":"stateProvinceName","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Postal/zip code\n"}],"serializedName":"postalCode","default":{"kind":"nothing"},"name":"postalCode","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"2-letter country code, in ISO 316-1 alpha-2 format.\n"}],"serializedName":"countryCode","default":{"kind":"nothing"},"name":"countryCode","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.common","name":"CountryCode"}},"parameters":[]}]}}]}},"name":"Address","version":{"kind":"nothing"}}};

export const snAddress: ADL.ScopedName = {moduleName:"ids.common", name:"Address"};

export function texprAddress(): ADL.ATypeExpr<Address> {
  return {value : {typeRef : {kind: "reference", value : snAddress}, parameters : []}};
}

export type PhoneCountryCode = string;

const PhoneCountryCode_AST : ADL.ScopedDecl =
  {"moduleName":"ids.common","decl":{"annotations":[{"v1":{"moduleName":"common.ui","name":"ValidRegex"},"v2":{"regex":"^\\d{1,3}$","description":"An E164 compliant phone number's international country code which allows up to 3 country code digits"}}],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}},"name":"PhoneCountryCode","version":{"kind":"nothing"}}};

export const snPhoneCountryCode: ADL.ScopedName = {moduleName:"ids.common", name:"PhoneCountryCode"};

export function texprPhoneCountryCode(): ADL.ATypeExpr<PhoneCountryCode> {
  return {value : {typeRef : {kind: "reference", value : snPhoneCountryCode}, parameters : []}};
}

export type PhoneNationalNumber = string;

const PhoneNationalNumber_AST : ADL.ScopedDecl =
  {"moduleName":"ids.common","decl":{"annotations":[{"v1":{"moduleName":"common.ui","name":"ValidRegex"},"v2":{"regex":"^\\d{1,14}$","description":"An E164 compliant national phone number which allows 1-14 digits with no special character formatting"}}],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}},"name":"PhoneNationalNumber","version":{"kind":"nothing"}}};

export const snPhoneNationalNumber: ADL.ScopedName = {moduleName:"ids.common", name:"PhoneNationalNumber"};

export function texprPhoneNationalNumber(): ADL.ATypeExpr<PhoneNationalNumber> {
  return {value : {typeRef : {kind: "reference", value : snPhoneNationalNumber}, parameters : []}};
}

export interface PhoneNumber {
  /**
   * The country code which forms the extension prefixed to the national number when dialling the number internationally
   */
  countryCode: PhoneCountryCode;
  /**
   * The national phone number
   */
  number: PhoneNationalNumber;
}

export function makePhoneNumber(
  input: {
    countryCode: PhoneCountryCode,
    number: PhoneNationalNumber,
  }
): PhoneNumber {
  return {
    countryCode: input.countryCode,
    number: input.number,
  };
}

const PhoneNumber_AST : ADL.ScopedDecl =
  {"moduleName":"ids.common","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The country code which forms the extension prefixed to the national number when dialling the number internationally\n"}],"serializedName":"countryCode","default":{"kind":"nothing"},"name":"countryCode","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ids.common","name":"PhoneCountryCode"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The national phone number\n"}],"serializedName":"number","default":{"kind":"nothing"},"name":"number","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ids.common","name":"PhoneNationalNumber"}},"parameters":[]}}]}},"name":"PhoneNumber","version":{"kind":"nothing"}}};

export const snPhoneNumber: ADL.ScopedName = {moduleName:"ids.common", name:"PhoneNumber"};

export function texprPhoneNumber(): ADL.ATypeExpr<PhoneNumber> {
  return {value : {typeRef : {kind: "reference", value : snPhoneNumber}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ids.common.StateCode" : StateCode_AST,
  "ids.common.CountryCode" : CountryCode_AST,
  "ids.common.StarRating" : StarRating_AST,
  "ids.common.Address" : Address_AST,
  "ids.common.PhoneCountryCode" : PhoneCountryCode_AST,
  "ids.common.PhoneNationalNumber" : PhoneNationalNumber_AST,
  "ids.common.PhoneNumber" : PhoneNumber_AST
};
